import * as React from 'react';
import type { SVGProps } from 'react';
const SvgAging = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 21"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M8.363 1.927a1 1 0 1 0 0 2H9v.69a7.002 7.002 0 0 0 1 13.93 7 7 0 0 0 5.362-11.5l.73-.73a1 1 0 0 0-1.415-1.415l-.809.81A6.96 6.96 0 0 0 11 4.617v-.69h.637a1 1 0 1 0 0-2zm1.735 4.941c-.023-.106-.174-.106-.196 0l-1.139 5.366a.65.65 0 0 0 .03.37c.43 1.098 1.983 1.098 2.413 0a.65.65 0 0 0 .03-.37z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgAging;
